import "./App.css";
import Header from "./Components/Header";
import Box from "@mui/material/Box";
import bg1 from "./Components/Assets/bg1.png";
import Maintext from "./Components/Maintext";
import Map from "./Components/Map";
import Hero from "./Components/Hero";
import Tecnology from "./Components/Tecnology";
import Community from "./Components/Community";

function App() {
  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${bg1})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundColor: "black",
        }}
      >
      <Header />
      <Maintext />
      </Box>
      <Map />
      <Hero />
      <Tecnology />
      <Community/>
    </>
  );
}

export default App;
